module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-row', {
    staticClass: "courseContent"
  }, [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.CAPS,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "600px",
      "row-style": {
        'height': '64px'
      }
    },
    on: {
      "selection-change": _vm.handleCoursesSelection,
      "row-click": function (row, column, event) { return _vm.handleRowClick('CAPTable', row, column, event); }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "课程属性",
      "prop": "courseProperties",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.coursePropertiesName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.courseName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类别",
      "width": "80",
      "align": "center",
      "prop": "courseCategoryName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.courseCategoryName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "90",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.score)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "90",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.totalTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "理论教学",
      "width": "90",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.theoryTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实验实训",
      "width": "90",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.practiseTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "90",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.examTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "各学期周数、学时分配",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "一"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.first,
      "prop": "term1",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term1, scope.row.week1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.second,
      "prop": "term2",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term2, scope.row.week2)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.third,
      "prop": "term3",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term3, scope.row.week3)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "四"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.fourth,
      "prop": "term4",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term4, scope.row.week4)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.fifth,
      "prop": "term5",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term5, scope.row.week5)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "六"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.sixth,
      "prop": "term6",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term6, scope.row.week6)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "七"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.seventh,
      "prop": "term7",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term7, scope.row.week7)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "八"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.eighth,
      "prop": "term8",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term8, scope.row.week8)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "九"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.ninth,
      "prop": "term9",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term9, scope.row.week9)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "十"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.tenth,
      "prop": "term10",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term10, scope.row.week10)))])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitJxjc
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeJxjcDialog
    }
  }, [_vm._v("取 消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3622f3a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/editCourseAndProgress.vue
// module id = 1809
// module chunks = 502